const initialFraudType = {
  fraudTypePermissions: {},
  fraudTypeLists: [],
  fraudTypeStatus: [],
  changedFraudTypeStatus: [],
  loadingFraudType: false,
  errorsFraudType: {},
};

const fraudTypeReducer = (fraudType = initialFraudType, action) => {
  switch (action.type) {
    case "GET_FRAUDTYPELIST_PENDING":
    case "ADD_FRAUD_TYPE_PENDING":
    case "UPDATE_FRAUD_TYPE_PENDING":
    case "UPDATE_FRAUD_TYPE_STATUS_PENDING":
    case "DELETE_FRAUD_TYPE_PENDING":
    case "GET_FRAUDTYPELISTBYID_PENDING":
      return { ...fraudType, loadingFraudType: true };

    case "GET_FRAUDTYPELIST_FULFILLED":
      return {
        ...fraudType,
        loadingFraudType: false,
        fraudTypeLists: action.payload,
        fraudTypeCount: action.count,
        fraudTypePermissions: action.permissions,
      };

    case "ADD_FRAUD_TYPE_FULFILLED":
    case "UPDATE_FRAUD_TYPE_FULFILLED":
    case "UPDATE_FRAUD_TYPE_STATUS_FULFILLED":
    case "DELETE_FRAUD_TYPE_FULFILLED":
      return {
        ...fraudType,
        loadingFraudType: false,
        changedFraudTypeStatus: action.payload,
      };

    case "GET_FRAUDTYPELISTBYID_FULFILLED":
      return {
        ...fraudType,
        loadingFraudType: false,
        fraudTypeLists: action.payload,
      };

    case "RESET_DELETE_FRAUD_TYPE_STATUS":
      return {
        ...fraudType,
        loadingFraudType: false,
        fraudTypeStatus: {},
        changedFraudTypeStatus: [],
        errorsFraudType: {},
      };

    case "GET_FRAUDTYPELIST_REJECTED":
    case "ADD_FRAUD_TYPE_REJECTED":
    case "UPDATE_FRAUD_TYPE_REJECTED":
    case "UPDATE_FRAUD_TYPE_STATUS_REJECTED":
    case "DELETE_FRAUD_TYPE_REJECTED":
    case "GET_FRAUDTYPELISTBYID_REJECTED":
      return {
        ...fraudType,
        loadingFraudType: false,
        errorsFraudType: action.payload,
      };

    default:
      return fraudType;
  }
};

export default fraudTypeReducer;
